// extracted by mini-css-extract-plugin
export default {"addToCartControl":"MZ-z","giftCard":"NZ-z","btnContainer":"OZ-z","cartButton":"PZ-z","disabled":"QZ-z"};